module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-38.a47a635b.svg";